export default {
  getTopTenKillers(state) {
    return state.topTenKillers;
  },
  getTopTenMethods(state) {
    return state.topTenMethods;
  },
  getMurderDates(state) {
    return state.murderDates;
  },
  getKillerSoap(state) {
    return state.killerSoap;
  },
  getMethodSoap(state) {
    return state.methodSoap;
  },
  getDeadlySoap(state) {
    return state.deadlySoap;
  },
  getMurderDeathData(state) {
    return state.MurderDeathData;
  },
  getMurderDetails(state) {
    return state.showMurderDetails;
  },
  

};
